
import EditRule from "../../EditActiveRule/EditActiveRule";
import { useNavigate } from "react-router-dom";

export default function ArchivedEditRule() {
  const navigate = useNavigate();

  const handleSaveAndTest = (data) => {
    // whatever extra thing you want to do for archived rules specifically
    console.log("Archived rule saved & tested:", data);
  };

  return (
    <EditRule
      isArchived={true}
      onSaveAndTest={handleSaveAndTest}
    />
  );
}